import { MyTaxCombinedTaxCreditInformationPage } from "my-tax/pages/my-tax-combined-tax-credit-information-page";
import { MyTaxCostTaxCreditInformationPage } from "my-tax/pages/my-tax-cost-tax-credit-information-page";
import { MyTaxFamilyTaxCreditInformationPage } from "my-tax/pages/my-tax-family-tax-credit-information-page";
import { MyTaxFirstMarriageTaxCreditInformationPage } from "my-tax/pages/my-tax-first-marriage-tax-credit-information-page";
import { MyTaxFourChildrenTaxCreditInformationPage } from "my-tax/pages/my-tax-four-children-tax-credit-information-page";
import { MyTaxMyPersonalTaxCreditInformationPage } from "my-tax/pages/my-tax-my-personal-tax-credit-information-page";
import { MyTaxUnderThirtyMothersTaxCreditInformationPage } from "my-tax/pages/my-tax-under-thirty-mothers-tax-credit-information-page";
import { MyTaxUnderTwentyFiveTaxCreditInformationPage } from "my-tax/pages/my-tax-under-twenty-five-tax-credit-information-page";
import { MyTaxThreeChildrenOrMoreTaxCreditInformationPage } from "my-tax/pages/my-tax-three-children-or-more-tax-credit-information-page";

export const myTaxCombinedTaxCreditInformationPageRoute =
  "/my-hr/combined-tax-credit-information";
export const myTaxFamilyTaxCreditInformationPageRoute =
  "/my-hr/family-tax-credit-information";
export const myTaxFourChildrenTaxCreditInformationPageRoute =
  "/my-hr/four-children-tax-credit-information";
export const myTaxMyPersonalTaxCreditInformationPageRoute =
  "/my-hr/my-personal-tax-credit-information";
export const myTaxUnderTwentyFiveTaxCreditInformationPageRoute =
  "/my-hr/under-twenty-five-tax-credit-information";
export const myTaxFirstMarriageTaxCreditInformationPageRoute =
  "/my-hr/first-marriage-tax-credit-information";
export const myTaxUnderThirtyMothersTaxCreditInformationPageRoute =
  "/my-hr/under-thirty-mothers-tax-credit-information";
export const myTaxCostTaxCreditInformationPageRoute =
  "/my-hr/cost-tax-credit-information";
export const myTaxThreeChildrenOrMoreTaxCreditInformationPageRoute =
  "/my-hr/three-children-or-more-tax-credit-information";

export const myTaxRoutes = [
  {
    id: "myTaxCombinedTaxCreditInformationPageRoute",
    path: myTaxCombinedTaxCreditInformationPageRoute,
    exact: true,
    private: false,
    component: MyTaxCombinedTaxCreditInformationPage,
    roles: [],
  },
  {
    id: "myTaxFamilyTaxCreditInformationPageRoute",
    path: myTaxFamilyTaxCreditInformationPageRoute,
    exact: true,
    private: false,
    component: MyTaxFamilyTaxCreditInformationPage,
  },
  {
    id: "myTaxFourChildrenTaxCreditInformationPageRoute",
    path: myTaxFourChildrenTaxCreditInformationPageRoute,
    exact: true,
    private: false,
    component: MyTaxFourChildrenTaxCreditInformationPage,
  },
  {
    id: "myTaxMyPersonalTaxCreditInformationPageRoute",
    path: myTaxMyPersonalTaxCreditInformationPageRoute,
    exact: true,
    private: false,
    component: MyTaxMyPersonalTaxCreditInformationPage,
  },
  {
    id: "myTaxUnderTwentyFiveTaxCreditInformationPageRoute",
    path: myTaxUnderTwentyFiveTaxCreditInformationPageRoute,
    exact: true,
    private: false,
    component: MyTaxUnderTwentyFiveTaxCreditInformationPage,
  },
  {
    id: "myTaxFirstMarriageTaxCreditInformationPageRoute",
    path: myTaxFirstMarriageTaxCreditInformationPageRoute,
    exact: true,
    private: false,
    component: MyTaxFirstMarriageTaxCreditInformationPage,
  },
  {
    id: "myTaxUnderThirtyMothersTaxCreditInformationPageRoute",
    path: myTaxUnderThirtyMothersTaxCreditInformationPageRoute,
    exact: true,
    private: false,
    component: MyTaxUnderThirtyMothersTaxCreditInformationPage,
  },
  {
    id: "myTaxCostTaxCreditInformationPageRoute",
    path: myTaxCostTaxCreditInformationPageRoute,
    exact: true,
    private: false,
    component: MyTaxCostTaxCreditInformationPage,
  },
  {
    id: "myTaxThreeChildrenOrMoreTaxCreditInformationPageRoute",
    path: myTaxThreeChildrenOrMoreTaxCreditInformationPageRoute,
    exact: true,
    private: false,
    component: MyTaxThreeChildrenOrMoreTaxCreditInformationPage,
    roles: [],
  },
];
